import { useCallback, useEffect } from 'react';
import CompletionReminderModal from '../CompletionReminderModal';
import { useCompletionReminderStorage } from '../../hooks/useCompletionReminderStorage';
import { useCompletionReminderTimer } from '../../hooks/useCompletionReminderTimer';

const log = (...args: unknown[]) => {
  console.debug('[CompletionReminder:Wrapper]', ...args);
};

interface Props {
  lessonId: string;
  completionStatus: string;
  isOnClassActivitiesTab: boolean;
  onMarkComplete: () => void;
}

const CompletionReminderWrapper = ({ lessonId, completionStatus, isOnClassActivitiesTab, onMarkComplete }: Props) => {
  useEffect(() => {
    log('Wrapper mounted/updated with props:', {
      lessonId,
      completionStatus,
      isOnClassActivitiesTab,
    });
  }, [lessonId, completionStatus, isOnClassActivitiesTab]);

  const { canShowReminder, recordDismissal, recordShown, rollbackShown } = useCompletionReminderStorage();

  const handleShow = useCallback(
    (id: string) => {
      recordShown(id);
    },
    [recordShown],
  );

  const { showModal, hideModal } = useCompletionReminderTimer({
    lessonId,
    completionStatus,
    isOnClassActivitiesTab,
    canShowReminder,
    onShow: handleShow,
    onNetworkHide: rollbackShown,
  });

  const handleDismiss = useCallback(() => {
    log('Modal dismissed, recording dismissal');
    recordDismissal(lessonId);
    hideModal();
  }, [lessonId, recordDismissal, hideModal]);

  const handleMarkComplete = useCallback(() => {
    log('Mark complete clicked');
    onMarkComplete();
  }, [onMarkComplete]);

  return <CompletionReminderModal show={showModal} onDismiss={handleDismiss} onMarkComplete={handleMarkComplete} />;
};

export default CompletionReminderWrapper;
